export class Lottery {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.lotteryTitle = form.lotteryTitle; // 开奖标题
      this.introduction = form.introduction; // 简介
      this.prizeInformationAddDTOList = form.prizeInformationAddDTOList ? form.prizeInformationAddDTOList : [{
        prizeLevel: 1,
        prizeName: "",
        prizeNum: null,
      }]; // 奖品信息
      this.personLotteryCodeNum = form.personLotteryCodeNum; // 每人可获抽奖码数
      this.linkObj = (form.objectId && form.objectType) ? {
        objectId: form.objectId,
        objectType: form.objectType,
        eventName: form.eventName || '',
      } : {
        objectId: null,
        objectType: null,
        eventName: '',
      };
      this.objectId = form.objectId; // 活动id
      this.objectType = form.objectType; // 活动类型
      this.lotteryRules = form.lotteryRules; // 抽奖规则
    } else {
      this.clear();
    }
  }
  get linkObj() {
    if (this.objectId && this.objectType) {
      return {
        objectId: this.objectId,
        objectType: this.objectType,
        eventName: this.eventName || '',
      };
    } else {
      return {
        objectId: null,
        objectType: null,
        eventName: this.eventName || '',
      };
    }
  }

  set linkObj(obj) {
    if (obj?.objectId && obj?.objectType) {
      this.objectId = obj.objectId;
      this.objectType = obj?.objectType;
      this.eventName = obj?.eventName || '';
    } else {
      this.objectId = null;
      this.objectType = null;
      this.eventName = '';
    }
  }
  formatForm() {
    if (this.prizeInformationAddDTOList?.length) {
      // 格式化掉没有名称的奖品
      this.prizeInformationAddDTOList = this.prizeInformationAddDTOList.filter((item, index) => {
        return item.prizeName && item.prizeNum && item.prizeNum !== '0';
      });
      // 再格式化变量中的类型
      if (this.prizeInformationAddDTOList.length) {
        this.prizeInformationAddDTOList = this.prizeInformationAddDTOList?.map((item) => {
          return {
            ...item,
            prizeNum: Number(item.prizeNum),
          };
        });
      }
    }
  }

  clear() {
    this.id = null;
    this.lotteryTitle = ''; // 开奖标题
    this.introduction = ''; // 简介
    this.prizeInformationAddDTOList = [{
      prizeLevel: 1,
      prizeName: "",
      prizeNum: null,
    }]; // 奖品配置
    this.personLotteryCodeNum = 1; // 每人可获抽奖码数
    this.objectId = null; // 活动id
    this.objectType = null; // 活动类型
    this.eventName = ''; // 活动名称
    this.linkObj = {
      objectId: null,
      objectType: null,
      eventName: '',
    };
    this.lotteryRules = ''; // 抽奖规则
  }
}
